/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getQualitySectionConfigs } from '../fn/quality-section-configs/get-quality-section-configs';
import { GetQualitySectionConfigs$Params } from '../fn/quality-section-configs/get-quality-section-configs';
import { QualitySectionConfig } from '../models/quality-section-config';

@Injectable({ providedIn: 'root' })
export class QualitySectionConfigsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `qualitySectionConfigControllerGetQualitySectionConfigs()` */
  static readonly QualitySectionConfigControllerGetQualitySectionConfigsPath =
    '/quality-section-configs/{programPeriodConfigId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getQualitySectionConfigs()` instead.
   *
   * This method doesn't expect any request body.
   */
  getQualitySectionConfigs$Response(
    params: GetQualitySectionConfigs$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<QualitySectionConfig>>> {
    return getQualitySectionConfigs(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getQualitySectionConfigs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getQualitySectionConfigs(
    params: GetQualitySectionConfigs$Params,
    context?: HttpContext
  ): Observable<Array<QualitySectionConfig>> {
    return this.getQualitySectionConfigs$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<QualitySectionConfig>>): Array<QualitySectionConfig> => r.body)
    );
  }
}
